import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IRecentActivities } from '../../models/recentActivities.model';
import { IDashboardReports } from '../../models/reports.model';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) {}

  public getReports(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/sale/reports/organization`,
      dateRange
    );
  }
  public getTopSoldItems(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/sale/reports/organization/activity`,
      dateRange
    );
  }

  public getDashboardReports(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/dashboard/POS_SALE`
    );
  }
  getReportsSalesSummary(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/reports/saleSummary`,
      dateRange
    );
  }

  getAdminDashboardReports(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}organization-sys-admin/report/systemData`
    );
  }

  getAdminNumberOfUsersReports(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}organization-sys-admin/report/organizations/users`
    );
  }

  getAdminNumberOfOrganizationReports(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}organization-sys-admin/report/organizations/types`
    );
  }
  getIncomeAndExpensesReports(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/reports/cashFlow`,
      dateRange
    );
  }
  getRecentActivities(): Observable<ISibasiHTTPResponse<IRecentActivities[]>> {
    return this.http.get<ISibasiHTTPResponse<IRecentActivities[]>>(
      `${environment.api_url}pos/reports/transactionHistory`
    );
  }
  getTotalPaymentAndCurrentMonthInvoiceTotal(): Observable<
    ISibasiHTTPResponse<IDashboardReports>
  > {
    return this.http.get<ISibasiHTTPResponse<IDashboardReports>>(
      `${environment.api_url}pos/reports/revenue/summary`
    );
  }

  getSystemAccessMetrics(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}user/admin/system/access/metrics`,
      dateRange
    );
  }
  getContactTransactionMetrics(
    dateRange: any,
    contactId: any
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/reports/transactions/filtered/metrics/${contactId}`,
      dateRange
    );
  }

  mostProfitableDay(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/reports/most-profitable-day`
    );
  }

  expenseReportCategory(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}expense/all/summary`,
      dateRange
    );
  }
  expenseReportSummary(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}expense/all/generalExpense/summary`,
      dateRange
    );
  }
  expenseReport(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}expense/all/summary`,
      dateRange
    );
  }
  profitMarginReport(dateRange: any): Observable<ISibasiHTTPResponse<any>> {
    return this.http.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/reports/organization/grossMargin`,
      dateRange
    );
  }
}
